// extracted by mini-css-extract-plugin
export default {"icon-button-root":"IconButton_icon-button-root__SAb7I","sm":"IconButton_sm__lil73","md":"IconButton_md__aGEOj","lg":"IconButton_lg__MO47j"};